import ReactInputMask from 'react-input-mask'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { schema } from '../../../../../../../validators/contactSchema'
import { Button } from '../../../../../../../components/Button'
import { Input } from '../../../../../../../components/FormElements/Input'
import { type ClientContactsFormValues } from '.'

type AddNewContactFormProps = {
  onCancel: () => void
  onSubmit: ({
    name,
    email,
    phone,
  }: ClientContactsFormValues['contacts'][0]) => void
}

export const AddNewContactForm = ({
  onSubmit,
  onCancel,
}: AddNewContactFormProps) => {
  const { control, handleSubmit, formState } = useForm<
  ClientContactsFormValues['contacts'][0]
  >({
    mode: 'onChange',
    resolver: yupResolver(schema),
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <fieldset className="mb-14">
        <div className="mb-4">
          <Controller
            name="name"
            control={control}
            render={({
              field: { value = '', onChange },
              fieldState: { invalid, error },
            }) => (
              <Input
                label="Nome do contato"
                placeholder="Nome do contato"
                value={value}
                onChange={onChange}
                isValid={!invalid && !!error}
                errorMessage={error?.message}
              />
            )}
          />
        </div>

        <div className="mb-4">
          <Controller
            name="email"
            control={control}
            render={({
              field: { value = '', onChange },
              fieldState: { invalid, error },
            }) => {
              return (
                <Input
                  label="E-mail"
                  placeholder="E-mail"
                  value={value}
                  onChange={onChange}
                  isValid={!invalid && !!error}
                  errorMessage={error?.message}
                />
              )
            }}
          />
        </div>

        <div className="mb-6">
          <Controller
            name="phone"
            control={control}
            render={({
              field: { value = '', onChange },
              fieldState: { invalid, error },
            }) => (
              <ReactInputMask
                mask="(99) 99999-9999"
                maskPlaceholder={null}
                value={value}
                onChange={onChange}
              >
                <Input
                  label="Telefone"
                  placeholder="(00) 00000-0000"
                  isValid={!invalid && !!error}
                  errorMessage={error?.message}
                />
              </ReactInputMask>
            )}
          />
        </div>
      </fieldset>

      <div className="flex gap-4">
        <Button type="button" variant="outline" fullWidth onClick={onCancel}>
          Cancelar
        </Button>
        <Button type="submit" disabled={!formState.isValid} fullWidth>
          Adicionar
        </Button>
      </div>
    </form>
  )
}
